module.exports = __webpack_public_path__ + "static/media/payment-result-success.e10ddd35.jpg";